import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { t } from 'i18next';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import * as Synonym from 'types/Synonym/Synonym';
import * as SynonymList from 'types/Synonym/SynonymList';
import * as Synonyms from 'types/Synonym/Synonyms';

interface IProps {
	cultureCode: string;
	disabled?: boolean;
	handleAddSynonym: () => void;
	handleChangeSynonym: (input: {
		index: number;
		text: string;
		key: 'nameSingular' | 'namePlural';
	}) => void;
	handleDeleteSynonym: (index: number) => void;
	synonyms: Synonyms.Type;
}

const SynonymsComponent = (props: IProps) => {
	const getSynonymsWithCultureCode = (): SynonymList.Type => {
		return props.synonyms[props.cultureCode] ?? [];
	};

	const renderSynonym = (input: Synonym.Type, key: number): JSX.Element => {
		return (
			<div className="col-3" key={`${key}-${props.cultureCode}`}>
				<fieldset className="fieldset-white">
					<div className="text-end">
						<RenderIf condition={!props.disabled}>
							<FontAwesomeIcon
								icon={faTrashCan}
								className="trash-can"
								onClick={() => props.handleDeleteSynonym(key)}
							/>
						</RenderIf>
					</div>
					<div className="form-group">
						<label>{t('_general:SINGULAR')}</label>
						<input
							className="form-control"
							disabled={props.disabled}
							error-key={`Synonyms['${props.cultureCode}'][${key}].NameSingular`}
							id={String(key)}
							name="nameSingular"
							onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
								props.handleChangeSynonym({
									index: key,
									text: e.currentTarget.value,
									key: 'nameSingular',
								})
							}
							type="string"
							value={input.nameSingular}
						/>
						<label>{t('_general:PLURAL')}</label>
						<input
							className="form-control"
							disabled={props.disabled}
							error-key={`Synonyms['${props.cultureCode}'][${key}].NamePlural`}
							id={String(key)}
							name="namePlural"
							onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
								props.handleChangeSynonym({
									index: key,
									text: e.currentTarget.value,
									key: 'namePlural',
								})
							}
							type="string"
							value={input.namePlural}
						/>
					</div>
				</fieldset>
			</div>
		);
	};

	return (
		<>
			<fieldset className="margin-top-25" style={{ minHeight: '4em' }}>
				<div className="d-flex">
					<legend>{t('_general:SYNONYMS')}</legend>
					<RenderIf condition={!props.disabled}>
						<button
							type="button"
							onClick={props.handleAddSynonym}
							className="btn btn-outline-primary"
							style={{ marginBottom: '18px', whiteSpace: 'nowrap' }}
						>
							{t('_general:NEW_SYNONYM')}
						</button>
					</RenderIf>
				</div>
				<div className="row gy-4">
					{getSynonymsWithCultureCode().map((synonym: Synonym.Type, i: number) => {
						return renderSynonym(synonym, i);
					})}
				</div>
			</fieldset>
		</>
	);
};

export default SynonymsComponent;
